import React from 'react';
import { toQueryParams } from '../../../../../../../../helpers/ajaxRequest';
import { API, AttraqtSuggestionsSearchTerm } from '../../../../../../../../types';
import suggestionStyles from './suggestion.module.pcss';

interface SuggestionProps {
  suggestion: AttraqtSuggestionsSearchTerm;
  input: string;
}

function Suggestion({ suggestion, input }: SuggestionProps): React.ReactElement {
  const { term, nrResults } = suggestion;
  const url = `${API.SEARCH}?${toQueryParams({ text: term })}`;
  const highlightedTerm = (term && highlight(term, input.toLowerCase())) || '';

  return (
    <a tabIndex={0} href={url} className={`search-suggestion__link ${suggestionStyles.suggestion}`}>
      <span className={suggestionStyles.suggestion__category} dangerouslySetInnerHTML={{ __html: highlightedTerm }} />
      <span className={suggestionStyles.suggestion__count}>{nrResults}</span>
    </a>
  );
}

function highlight(str: string, input: string): string {
  const reg = new RegExp(input, 'i');
  return str?.replace(reg, input && `<strong>${input}</strong>`);
}

export default Suggestion;
